import { render, staticRenderFns } from "./FaqModal.vue?vue&type=template&id=6abd099a&scoped=true&"
import script from "./FaqModal.vue?vue&type=script&lang=js&"
export * from "./FaqModal.vue?vue&type=script&lang=js&"
import style0 from "./FaqModal.vue?vue&type=style&index=0&id=6abd099a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abd099a",
  null
  
)

export default component.exports